export default {
    drag_and_drop: 'Перетащите файлы для загрузки изображений или',
    browse_files: 'Выберите файлы',
    your_uploads: 'Ваши загрузки',
    allowed_types: 'Разрешенные типы: .png .jpg .jpeg',
    wrong_file_type: 'Некоторые из ваших изображений имеют неверный тип файла. \n Разрешенные типы: .png .jpg .jpeg',
    max_number: 'Максимальное количество файлов: {n}',
    files_over_limit: 'Максимальный лимит для каждого файла: {n} МБ',
    add_image_here: 'Добавить изображение здесь',
    cant_delete_main_image:
        'Основное изображение нельзя удалить! Пожалуйста, выберите другое изображение для основного и затем удалите это.',
    set_main: 'Установить как основное',
    invalid_image: 'Некоторые из ваших изображений недействительны. Они не будут загружены!',
    invalid_file: 'Недопустимый файл',
}
